import _ from 'lodash'
import { Map } from 'immutable'

import { VIRTUAL_LIST_FORCE_RENDER } from './constants'

export default (state = Map(), action = {}) => {
    switch (action.type) {
        case VIRTUAL_LIST_FORCE_RENDER: {
            const id = _.get(action, 'data.id', null)
            if (!id) return state

            const currentValue = state.getIn([id, 'forceRenderFlag'], false)

            return state.setIn([id, 'forceRenderFlag'], !currentValue)
        }
        default:
            return state
    }
}
